export const STORE_TOKEN = 'STORE_TOKEN';
export const SIGNOUT = 'SIGNOUT';
export const SIGNUP = 'SIGNUP';
export const AUTH_TOKEN = 'auth_token'
export const MASQUERADE = 'masquerade'
export const DISABLE_MASQUERADE = 'disable_masquerade'